import { OktaAuthOptions } from '@okta/okta-auth-js';
import { environment } from 'src/environments/environment';

export class OktaConfigProvider {
  static issuer = environment.issuer;
  static clientId = environment.clientId;
  static getConfig(): OktaAuthOptions {
    return {
      issuer: this.issuer,
      clientId: this.clientId,
      redirectUri: window.location.origin,
      postLogoutRedirectUri: window.location.origin,
    };
  }
  static setConfig(issuer: string, clientId: string) {
    this.issuer = issuer;
    this.clientId = clientId;
  }
}